module.exports = __webpack_public_path__ + "img/insta.f0913af.svg";